<template>
  <div class="makissue">
    <!-- <span class="order">{{order}}.</span> -->
    <div class="issue" @mouseover="operateshow" @mouseleave="operatehide">
      <issue
        v-if="!isedit"
        total="0"
        :order="order"
        :message="message"
        :disabled="true"
        :showasw="false"
      ></issue>
      <component v-if="isedit" :is='comp' @exit="exit" @complate="complate" :isedit="isedit" :message="message"></component>
      <div style="height:0.3rem;margin-top:5px;" >
        <div class="operate" v-if="isoperate">
          <div class="edit" @click="edit">
            <img src="../assets/icons/edit.png">
          </div>
          <!-- <div class="copy" @click="copy"><img src="../assets/icons/copy.png"></div> -->
          <div class="del" @click="del">
            <img src="../assets/icons/delete.png">
          </div>
          <div class="moveup" @click="moveup">
            <img src="../assets/icons/moveup.png">
          </div>
          <div class="movedown" @click="movedown">
            <img src="../assets/icons/movedown.png">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import issue from "./issue";
// import make from "./make";
export default {
  data() {
    return {
      isoperate: false,
      isedit: true,
      comp:'yu'
    };
  },
  props: ["message", "order"],
  components: {
    issue,
    // make
    yu: {template: `<div></div>`},
  },
  mounted() {
    // if(this.message.questionid&&(this.message.qbtitle==undefined)){
    //     this.isedit=false
    // }
    if (this.message.isedit) {
      this.isedit = true;
      this.comp = 'make'
    } else {
      this.isedit = false;
    }
  },
  methods: {
    exit() {
      this.isedit = false;
      this.$emit("exit", this.order - 1);
    },
    complate(data) {
      this.isedit = false;
      this.$emit("complated", data, this.order);
    },
    edit() {
      if (this.message.hasedit) {
        this.errorPlus("有题目在编辑状态,请完成编辑后操作!");
        return;
      }
      this.isedit = true;
      this.comp = 'make'
      this.isoperate = false;
      this.$emit("isedit", this.order - 1, true);
    },
    copy() {
      this.$emit("copyitem", this.order - 1);
    },
    del() {
      this.$emit("delitem", this.order - 1);
    },
    moveup() {
      this.$emit("moveupitem", this.order - 1);
    },
    movedown() {
      this.$emit("movedownitem", this.order - 1);
    },
    operateshow() {
      if (!this.isedit) {
        this.isoperate = true;
      }
    },
    operatehide() {
      this.isoperate = false;
    }
  }
};
</script>
<style lang="css" scoped>
.makissue {
  display: flex;
  border-radius: 10px;
  padding: 5px;
}
.makissue:hover {
  background: #e9effa;
}
.order {
  font-size: 14px;
  font-style: italic;
  margin-right: 0.1rem;
  line-height: 26px;
}
.issue {
  width: calc(100% - 30px);
}
.operate {
  display: flex;
  justify-content: flex-end;
}
.operate > div {
  margin: 0 0.1rem;
}
</style>


// WEBPACK FOOTER //
// src/components/makeissue.vue